module.exports = __webpack_public_path__ + "img/blog-5.d18708f1.jpg";